const HeroVect1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1006"
      height="843"
      viewBox="0 0 1006 843"
      fill="none"
    >
      <path
        d="M847.158 0L36.6559 120.986L0 843H1006L847.158 0Z"
        fill="#3D3C98"
      />
    </svg>
  );
};
export default HeroVect1;
